import * as React from 'react';
import classnames from 'classnames';
import omit from 'lodash/omit';
import withThemeConfig from '../../_utils/withThemeConfig';

var SidebarItem = function SidebarItem(props) {
  var icon = props.icon,
      title = props.title,
      url = props.url,
      active = props.active;
  var Link = props.themeConfig.baseComponents.Link;
  var otherLinkProps = omit(props, ['title', 'icon', 'url', 'to', 'active', 'themeConfig']);
  var className = classnames('SidebarItem', {
    'SidebarItem--active': active
  });
  return React.createElement("li", {
    className: className
  }, React.createElement(Link, Object.assign({}, otherLinkProps, {
    icon: icon,
    to: url,
    "aria-current": active && 'page'
  }), title));
};

SidebarItem.defaultProps = {
  url: undefined,
  active: false
};
SidebarItem.displayName = 'Sidebar.Item';
export default withThemeConfig(SidebarItem);